import Vue from 'vue';

Vue.component('enterprise-dropdown-component', {
    data() {
        return {
            selected: 1,
            tabIndex: 0,
        };
    },

    mounted() {},

    methods: {
        setOption(e) {
            this.selected = parseInt(e.target.value);
        },

        switchTab(index) {
            if (index != this.tabIndex) {
                this.tabIndex = index;
            }
        },
    },
});
